var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fn-ui-layout-navigation-header",class:{'fn-ui-layout-navigation-header--compact' : _vm.compact}},[_vm._v(" "+_vm._s(_vm.compact ? _vm.titleCompact : _vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }